<template>
	<div class="UserFormActions">
		<BaseButton type="submit" outlined @click="$emit('submittedWithPdf', true)">
			<svg xmlns="http://www.w3.org/2000/svg" width="16px" height="14px" viewBox="0 0 16 14">
				<path fill="currentColor" d="M13.6,3.889H2.4C1.072,3.889,0,4.931,0,6.222v4.667h3.2V14h9.6v-3.111 H16V6.222C16,4.931,14.928,3.889,13.6,3.889z M11.2,12.444H4.8V8.556h6.4V12.444z M13.6,7c-0.439,0-0.8-0.35-0.8-0.778 s0.36-0.778,0.8-0.778c0.44,0,0.801,0.35,0.801,0.778S14.04,7,13.6,7z M12.8,0H3.2v3.111h9.6V0z"></path>
			</svg>
			Vytisknout nabídku
		</BaseButton>
		<BaseButton href="https://zelenekolo.cz/rezervace/" target="_blank" rel="noopener" outlined>
			<svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 15 15">
				<path fill="currentColor" d="M4.375,0h-1.25v1.875h1.25V0z M12.5,0v2.5H10V0H5v2.5H2.5V0H0v15h15V0 H12.5z M13.75,13.75H1.25v-10h12.5V13.75z M11.875,0h-1.25v1.875h1.25V0z M10.625,8.125h-6.25v1.25h6.25V8.125z"></path>
			</svg>
			Rezervovat schůzku
		</BaseButton>
		<BaseButton type="submit" @click="$emit('submittedWithPdf', false)">
			<svg xmlns="http://www.w3.org/2000/svg"  width="13px" height="13px" viewBox="0 0 13 13">
				<path fill="currentColor" d="M12.932,0.869c0.063-0.106,0.08-0.24,0.063-0.364 c-0.045-0.329-0.355-0.55-0.674-0.497c-0.071,0.009-0.151,0.036-0.213,0.071L0.299,5.988C0.184,6.042,0.086,6.139,0.033,6.263 c-0.044,0.125-0.044,0.267,0,0.391C0.06,6.787,0.131,6.902,0.237,6.982c0.106,0.081,0.23,0.125,0.363,0.125h5.319v5.323 c0,0.134,0.044,0.258,0.124,0.364c0.08,0.106,0.195,0.177,0.328,0.204h0.142c0.213,0.018,0.408-0.089,0.514-0.275L12.932,0.869 L12.932,0.869z"></path>
			</svg>
			Poptat
		</BaseButton>
	</div>
</template>

<style lang="scss" scoped>
.UserFormActions {
	display: flex;
	justify-content: space-between;
	width: 100%;
	margin-top: 2.4em;
	margin-left: -.2rem;
	margin-right: -.2rem;
	@media (max-width: 680px) {
		flex-wrap: wrap;
	}

	:deep(a), :deep(button) {
		text-align: left;
		margin: .2rem;

		@media (max-width: 680px) {
			width: calc(50% - .4rem);
		}

		@media (max-width: 500px) {
			width: calc(100% - .4rem);
		}
	}
}
</style>